import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.firstLevel = this.el.querySelectorAll('.c-nav-overlay__item.-lvl-0.-has-children');
        this.navToggle = document.querySelector('.c-header-navtoggle');
        this.navOverlay = document.querySelector('.c-nav-overlay__bg');

        this.firstLevel.forEach((item) => {
            const link = item.querySelector('.c-nav-overlay__link');
            const linkUrl = link.getAttribute('href');
            const linkData = link.getAttribute('data-text');
            const text = link.querySelector('.c-nav-overlay__text');
            const emptySpan = document.createElement('span');
            text.setAttribute('data-text', linkData);
            text.prepend(emptySpan);
            // replace link tag with span and keep classes
            link.removeAttribute('href');
            const span = document.createElement('span');
            span.innerHTML = link.innerHTML;
            span.classList = link.classList;
            link.parentNode.replaceChild(span, link);
            // add event listener on link wich have been generated
            span.addEventListener('click', () => {
                this.toggleSubNav(item);
            });
            // prepend text inside .c-subnav that is inside item, with class .c-subnav__title, use var link and make it a <a> tag
            const subnav = item.querySelector('.c-subnav');
            const title = document.createElement('a');
            const titleContent = document.createElement('span');
            titleContent.innerHTML = text.innerHTML;
            title.appendChild(titleContent);
            title.setAttribute('href', linkUrl);
            title.classList.add('c-subnav__title', 'o-title-4');
            subnav.prepend(title);
            // wrap supnav with div
            const wrapper = document.createElement('div');
            wrapper.classList.add('c-subnav__wrapper');
            subnav.parentNode.replaceChild(wrapper, subnav);
            wrapper.appendChild(subnav);
        });

        this.navToggle.addEventListener('click', () => {
            this.closeAll();
        });

        this.navOverlay.addEventListener('click', () => {
            this.closeAll();
        });
    }

    toggleSubNav(item) {
        item.classList.toggle('-is-open');

        if (item.classList.contains('-is-open')) {
            this.closeAll();
            item.classList.add('-is-open');
        }
    }

    closeAll() {
        this.firstLevel.forEach((item) => {
            item.classList.remove('-is-open');
        });
    }
}
